import React from 'react';
import ProductCheckout from '../ProductCheckout';
import Outer from './Outer';
import Container from './Container';
import commercePropTypes from '../../prop-types/commercePropTypes';

var RibbonCheckout = function RibbonCheckout(_ref) {
  var price = _ref.price,
      currency = _ref.currency,
      discount = _ref.discount,
      availableStyles = _ref.availableStyles,
      onProductChange = _ref.onProductChange,
      onProductSubmit = _ref.onProductSubmit,
      isSubmitting = _ref.isSubmitting,
      backgroundColor = _ref.backgroundColor,
      index = _ref.index;
  return /*#__PURE__*/React.createElement(Outer, null, /*#__PURE__*/React.createElement(Container, {
    backgroundColor: backgroundColor
  }, /*#__PURE__*/React.createElement(ProductCheckout, {
    isRow: true,
    price: price,
    currency: currency,
    discount: discount,
    availableStyles: availableStyles,
    onProductChange: onProductChange,
    onProductSubmit: onProductSubmit,
    index: index,
    isSubmitting: isSubmitting,
    showStyleOptionsLabel: false
  })));
};

RibbonCheckout.defaultProps = {
  price: undefined,
  discount: undefined,
  onProductSubmit: null,
  onProductChange: null,
  currency: undefined,
  isSubmitting: false,
  backgroundColor: undefined
};
export default RibbonCheckout;